import { render, staticRenderFns } from "./PageSendVerifyEmail.vue?vue&type=template&id=6963d330&scoped=true&"
import script from "./PageSendVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./PageSendVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./PageSendVerifyEmail.vue?vue&type=style&index=0&id=6963d330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963d330",
  null
  
)

export default component.exports